export const CALENDAR_MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const CALENDAR_PICKER_ITEM_HEIGHT_PX = 28;
export const CALENDAR_PICKER_VIEWPORT_HEIGHT_PX = 144;
export const CALENDAR_PICKER_EDGE_PADDING_PX =
  (CALENDAR_PICKER_VIEWPORT_HEIGHT_PX - CALENDAR_PICKER_ITEM_HEIGHT_PX) / 2;

export function buildCalendarPickerYears(anchorYear) {
  const years = [];
  for (let year = anchorYear - 5; year <= anchorYear + 5; year += 1) {
    years.push(year);
  }
  return years;
}

export function calendarPickerMonthItems() {
  return CALENDAR_MONTH_NAMES.map((name, index) => ({ name, index }));
}

export function calendarPickerSnapIndex(scrollTop, itemCount) {
  const index = Math.round(scrollTop / CALENDAR_PICKER_ITEM_HEIGHT_PX);
  return Math.max(0, Math.min(itemCount - 1, index));
}

export function calendarPickerItemTop(index) {
  return index * CALENDAR_PICKER_ITEM_HEIGHT_PX;
}
